<template>
  <div id="FanCoilOthers" class="page product-list">
    <div class="page-top-container">
      <div class="select-product-block line-no-wrap">
        <span class="block-title after-line">已选产品</span>
        <el-tooltip
            :disabled="selectProduct.model && selectProduct.model.length < 80"
            effect="light"
            :content="selectProduct.model"
            placement="bottom-start"
        >
          <span class="name-span">{{selectProduct.model || '暂无'}}</span>
        </el-tooltip>
        <el-button v-if="selectProduct.id" type="text" @click="chooseDetail(selectProduct)">查看</el-button>
      </div>
      <div class="search-bar">
        <span class="search-bar-title" @click="()=>{ isFold = !isFold }">
          <i class="el-icon-arrow-right rotate-icon" :class="{'icon-fold':isFold}" />
          选型条件
        </span>
        <gjw-dimensions @height-changed="searchBoxHeightChange">
          <div class="search-content-box" :class="{'fold-height':isFold}">
            <fan-coil-search
                ref="fanCoilSearch"
                from="FanCoilOthers"
                :init-value="rowSearch"
                :temperature-min="roomSummerTempMin"
                :temperature-max="roomWinterTempMax"
            />
            <div class="search-btn-box">
              <el-button type="primary" size="medium" @click="reChoose">选&nbsp;&nbsp;型</el-button>
            </div>
          </div>
        </gjw-dimensions>
      </div>
    </div>
    <div class="search-innerbox">
      <el-table
        v-if="tableData.length"
        :data="tableData"
        v-loading="tableLoading"
        :max-height="tableHeight"
        style="width: 100%"
        :cell-style="cellStyle"
      >
        <el-table-column prop="model" label="产品型号" width="320px">
          <template slot-scope="scope">
            <div class="model-container">
              <span class="img-tab-container">
                <img
                  v-if="scope.row.imageUrl"
                  class="product-img"
                  :src="scope.row.imageUrl"
                  alt=""
                  @error="imageUrlFailed = true"
                />
                <img
                  v-else
                  class="product-img"
                  :src="productImage"
                  alt=""
                  @error="imageUrlFailed = true"
                />
              </span>
              <span class="modelRow" style="color: #4897f5">{{ scope.row.model }}</span>
              <span class="modelRow modeproductSeries">产品系列：{{ scope.row.productSeriesName }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="medium_air_flow"
          :render-header="renderHeader"
          :label="medium_air_flow"
          min-width="102px"
        >
        </el-table-column>
        <el-table-column
          prop="medium_total_heat"
          :render-header="renderHeader"
          :label="medium_total_heat"
          width="102px"
        >
        </el-table-column>
        <el-table-column
          prop="medium_sensible_heat"
          :render-header="renderHeader"
          :label="medium_sensible_heat"
          width="102px"
        >
        </el-table-column>
        <el-table-column
          prop="medium_latent_heat"
          :render-header="renderHeader"
          :label="medium_latent_heat"
          width="102px"
        >
        </el-table-column>
        <el-table-column
          prop="medium_cooling_heating_and_humidity_ratio"
          :render-header="renderHeader"
          :label="medium_cooling_heating_and_humidity_ratio"
          width="102px"
        >
        </el-table-column>
        <el-table-column
          prop="medium_heating"
          :render-header="renderHeader"
          :label="medium_heating"
          width="102px"
        >
        </el-table-column>
        <el-table-column label="操作" width="120px">
          <template slot-scope="scope">
            <div v-if="selectProduct.id === scope.row.id" class="iconSuccess">
              <i class="el-icon-success"></i>
              <span>已选</span>
            </div>
            <el-button
                v-else
                style="margin-right: 14px; background: #4897f5; color: #fff"
                type="button"
                size="small"
                @click="onSelectRow(scope.$index, scope.row)"
            >选择</el-button>
            <el-button
              @click="chooseDetail(scope.row)"
              type="text"
              size="small"
              style="color: #4897f5"
            >查看</el-button>
          </template>
        </el-table-column>
      </el-table>
      <empty-content v-else text="根据您的选型条件暂无匹配的产品型号，请修改选型条件后重试" />
      <!-- 抽屉 -->
      <el-drawer
        close-on-click-modal
        custom-class="product-detail-drawer"
        :append-to-body="true"
        :modal="true"
        :direction="direction"
        :visible.sync="drawer"
        :size="drawerWidth"
      >
        <fan-coil-detail :productIds="productId" />
      </el-drawer>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import FanCoilSearch from './components/batchSelection/FanCoilSearch.vue'
import FanCoilDetail from './FanCoilDetail.vue'
import EmptyContent from '@/components/business/EmptyContent.vue'
import GjwDimensions from '@/components/lib/GjwDimensions.vue'

export default {
  name: 'FanCoilOthers',
  props: {
    currentRow: {
      type: Object,
      default() {
        return {}
      },
    },
    room: {
      type: Object,
      default() {
        return {}
      }
    },
    productRow: {
      type: Array,
      default() {
        return []
      },
    },
    rowSearch: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  components: {
    FanCoilSearch,
    FanCoilDetail,
    EmptyContent,
    GjwDimensions,
  },
  data() {
    return {
      tableLoading: false,
      pageSize: 50,
      // 选型条件是否收起
      isFold: true,
      tableHeight: (document.body.clientHeight - 196).toFixed(0),
      // 房间的产品搜索条件
      searchData: {},
      selectProduct: {
        searchData: {}
      },
      isMediumLevel: this.rowSearch.level === 'MEDIUM_LEVEL',
      drawer: false,
      productId: '',
      direction: 'ltr',
      drawerWidth: '1040px',
      tableData: [],
      medium_air_flow: '中档风量(㎡/h)',
      medium_total_heat: '中档全冷(kW)',
      medium_sensible_heat: '中档显冷(kW)',
      medium_latent_heat: '中档潜冷(kW)',
      medium_cooling_heating_and_humidity_ratio: '中档制冷热湿比 || (kJ/kg)',
      medium_heating: '中档制热(kW)',
      // 品类编码
      gjwCategoryCode: 'C000006',
      // 品类名称
      gjwCategoryName: '风机盘管',
    }
  },
  computed: {
    ...mapGetters({
      detail: 'productDetail/detail',
    }),
    productImage() {
      return require('@/assets/image/default_product_img.png')
    },
    roomSummerTempMin() {
      const { summerDryBulbTemperature, summerWetBulbTemperature } = this.room
      return summerDryBulbTemperature - summerWetBulbTemperature >= 0 ? summerWetBulbTemperature : summerDryBulbTemperature
    },
    roomWinterTempMax() {
      return this.room.winterDryBulbTemperature
    },
  },

  watch: {
    currentRow: {
      handler(newValue, oldValue) {
        // 触发选型结果
        this.initPage()
      },
    },
  },

  mounted() {
    // 触发选型结果
    this.initPage()
  },

  methods: {
    ...mapActions({
      // 获取产品详情
      loadProperties: 'productDetail/loadProperties',
      loadDetail: 'productDetail/loadDetail',
      loadRelatedComponents: 'productDetail/loadRelatedComponents',
      loadRelatedBlocks: 'productDetail/loadRelatedBlocks',
    }),

    ...mapMutations({
      setProductId: 'productDetail/setProductId',
    }),

    // 初始化页面
    initPage() {
      // 如果未找到合适规格，则不展示表格
      if (this.currentRow.id) {
        const data = this.$refs.fanCoilSearch.getSearchData()
        this.searchData = { ...data.searchData }
        this.isMediumLevel = data.isMediumLevel
        this.changeHeader()
        this.getTableList()
      } else {
        this.selectProduct = {
          searchData: {}
        }
        this.reChooseProductIds = []
        this.tableData = []
      }
    },
    // 选择最优
    getTableList(from, productIds) {
      const isReChoose = from === 'reChoose'
      const parameter_values = {
        paramsObj: {
          productIds: isReChoose ? productIds : this.productRow,
        },
        parameter_filter: this.isMediumLevel ? 'ALTERNATIVE_MEDIUM_LEVEL' : 'ALTERNATIVE_HIGH_LEVEL',
      }
      this.$api.products.parameter_values(parameter_values).then((res) => {
        const that = this
        const list = res || []
        list.forEach((v) => {
          if (this.isMediumLevel) {
            v.parameters.forEach((j) => {
              j.name === '中档风量' && (v.medium_air_flow = j.value)
              j.name === '中档全冷' && (v.medium_total_heat = j.value)
              j.name === '中档显冷' && (v.medium_sensible_heat = j.value)
              j.name === '中档制热' && (v.medium_heating = j.value)
              j.name === '中档制冷热湿比' && (v.medium_cooling_heating_and_humidity_ratio = j.value)
              j.name === '中档潜冷' && (v.medium_latent_heat = j.value)
            })
          } else {
            v.parameters.forEach((j) => {
              j.name === '高档风量' && (v.medium_air_flow = j.value)
              j.name === '高档全冷' && (v.medium_total_heat = j.value)
              j.name === '高档显冷' && (v.medium_sensible_heat = j.value)
              j.name === '高档制热' && (v.medium_heating = j.value)
              j.name === '高档制冷热湿比' && (v.medium_cooling_heating_and_humidity_ratio = j.value)
              j.name === '高档潜冷' && (v.medium_latent_heat = j.value)
            })
          }
        })
        that.tableData = JSON.parse(JSON.stringify(list))
        // console.log('that.tableData:', that.tableData)
        if (!isReChoose) {
          this.selectProduct = that.tableData.find((item) => { return item.id === this.currentRow.id }) || {}
          this.selectProduct.searchData = { ...this.currentRow.searchData }
          this.reChooseProductIds = [...this.productRow]
        }
      }).finally(() => {
        this.tableLoading = false
      })
    },
    searchBoxHeightChange(obj) {
      const height = obj.newValue || 0
      const maxHeight = document.body.clientHeight - height - 130
      this.tableHeight = maxHeight.toFixed(0)
    },
    // 改变查询条件后，重新选型
    reChoose() {
      this.tableLoading = true
      const data = this.$refs.fanCoilSearch.getSearchData()
      this.searchData = { ...data.searchData }
      this.isMediumLevel = data.isMediumLevel
      const productProperties = data.productProperties
      const validationProperties = data.validProperties
      const nonValidationProperties = data.nonValidProperties
      const roomInfo = [this.room]
      const paramsForMulti_room = {
        topSize: this.pageSize,
        brandCode: this.searchData.brandCode,
        inputCondition: roomInfo,
        dustCorrectionFactor: this.isMediumLevel ? null : this.searchData.dustCorrectionFactor,
        intermittentUseFactor: this.isMediumLevel ? null : this.searchData.intermittentUseFactor,
        level: this.searchData.level,
        productProperties: productProperties,
        validationProperties: validationProperties,
        nonValidationProperties: nonValidationProperties,
        singleUnitResponsibilityArea: this.searchData.singleUnitResponsibilityArea,
        summerSupplyWaterTemperature: this.searchData.summerSupplyWaterTemperature,
        winterSupplyWaterTemperature: this.searchData.winterSupplyWaterTemperature,
      }
      this.$api.products.getMulti_room(this.gjwCategoryCode, paramsForMulti_room).then((res) => {
        this.reChooseProductIds = res[0].productIds
        if (this.reChooseProductIds && this.reChooseProductIds.length) {
          this.getTableList('reChoose', this.reChooseProductIds)
        } else {
          this.tableLoading = false
          this.tableData = []
        }
      }).catch(() => {
        this.tableLoading = false
        this.$msgbox(
          '存在不合理的输入值，请检查是否符合实际情况并重新输入。',
          '提示',
          {
            confirmButtonText: '确定',
            callback: (action) => {
              this.$message({
                type: 'info',
                message: `action: ${action}`,
              })
            },
          }
        )
      })
    },

    // 选择
    onSelectRow(index, row) {
      this.selectProduct = row
      this.selectProduct.searchData = { ...this.searchData }
      const obj = {
        row: { ...this.selectProduct, productIds: this.reChooseProductIds },
        index: index
      }
      this.$emit('selectRow', obj)
      // 选择备选结果埋点
      this.$tracks({
        event: 'selectAlternative',
        params: {
          g_c_class_code: this.gjwCategoryCode,
          g_c_class_name: this.gjwCategoryName,
          g_c_product_id: row.id,
          g_c_product_name: row.name,
        },
      })
    },

    // 更改表头
    changeHeader() {
      const letter = this.isMediumLevel ? '中' : '高'
      this.medium_air_flow = `${letter}档风量 || (㎡/h)`
      this.medium_total_heat = `${letter}档全冷 || (kW)`
      this.medium_sensible_heat = `${letter}档显冷 || (kW)`
      this.medium_latent_heat = `${letter}档潜冷 || (kW)`
      this.medium_cooling_heating_and_humidity_ratio = `${letter}档制冷热 || 湿比(kJ/kg)`
      this.medium_heating = `${letter}档制热 || (kW)`
    },

    // 列表头换行
    renderHeader(h, { column, $index }) {
      const columnArr = column.label.split('||') // 此处换行标志
      if (columnArr.length >= 2) {
        const divArr = []
        columnArr.map((item) => {
          divArr.push(h('div', { style: 'text-align: center ' }, item))
        })
        return h('div', {}, divArr)
      }
      return h('div', {}, column.label)
    },

    // 设置行样式
    cellStyle({ row, column, rowIndex, columnIndex }) {
      let cellStyle
      if (this.selectProduct.id === row.id) {
        cellStyle = 'background:#E9F2FE'
      }
      return cellStyle
    },

    // 查看详情
    async chooseDetail(row) {
      this.drawer = true
      this.setProductId(row.id)
      this.productId = row.id
      // 获取产品详情
      this.loadProperties().then()
      this.loadDetail().then()
      this.loadRelatedComponents().then()
      this.loadRelatedBlocks().then()
      const projectInfo = await this.getProjectInfo()
      // 查看详情埋点
      this.$tracks({
        event: 'visitProductDetail',
        params: {
          g_c_class_code: this.gjwCategoryCode,
          g_c_class_name: this.gjwCategoryName,
          g_c_product_id: row.id,
          g_c_product_name: row.name,
          g_c_source: 'alternative',
          g_c_project_id: projectInfo.id,
          g_c_project_file_path: projectInfo.path,
          g_c_project_file_name: projectInfo.name
        },
      })
    },
  },
}
</script>

<style lang="less" scoped>
.product-list {
  width: 1110px !important;
  display: flex;
  flex-direction: column;
  padding-bottom: 10px;
  font-size: 12px;
  .search-innerbox {
    padding: 0 20px;
    flex: 1;
  }
}
.page-top-container{
  padding: 0 20px;
}
.select-product-block{
  background: #E9F2FE;
  border-radius: 6px;
  padding: 0 14px;
  margin-bottom: 10px;
  height: 32px;
  line-height: 32px;
  .block-title{
    margin-right: 10px;
    padding-right: 10px;
  }
  .name-span{
    margin-right: 10px;
  }
}
.search-bar{
  margin-bottom: 8px;
}
.search-bar-title{
  color: #009ee1;
  cursor: pointer;
  .rotate-icon {
    display: inline-block;
    transform: rotate(90deg);
    transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);

    &.icon-fold {
      transform: rotate(0deg);
    }
  }
}
.search-content-box{
  box-sizing: border-box;
  border-top: 1px solid #d2d9e3;
  margin: 8px 0;
  height: 194px;
  overflow: hidden;
  transition: height 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  &.fold-height{
    height: 0;
    border: none;
  }
}
.search-btn-box{
  margin-top: 8px;
  text-align: right;
}

/deep/div.search-innerbox .el-table__row {
  height: 64px !important;
}
/deep/.el-table th {
  padding: 0 !important;
}
/deep/.el-table td {
  padding: 0 !important;
}
/deep/.el-input-number--mini {
  width: 116px;
  line-height: 22px;
}
/deep/.el-button {
  margin-left: 0 !important;
}

.iconSuccess {
  display: unset;
  margin-right: 18px;
  height: 32px;
  width: 60px;
}
.confirm {
  color: #2dafcd !important;
}

.el-icon-success {
  margin: 0 8px;
  color: #4897f5;
}
/deep/.custom-icon {
  width: 30px;
  height: 30px;
  background: url("./img/icon_info.png");
}
.model-container {
  .product-img {
    width: 54px;
    height: 54px;
    margin-left: 10px;
    margin-top: 5px;
    background: #f3f3f3;
  }
  .modelRow {
    position: absolute;
    top: 8px;
    margin-left: 4px;
    width: 220px;
  }
  .modeproductSeries {
    top: 30px;
  }
}
</style>
